import { css } from "@emotion/react";
import { memo } from "react";
import { pageCSS } from "../../templates/PageTemplate";

const Information = () => {
  return (
    <div
      id="privilege"
      css={css`
        margin-top: -10%;
        background-color: #d65b56;
      `}
    >
      <section
        css={css`
          max-width: 860px;
          margin: 0 auto;
          padding: 80px;
          @media screen and (max-width: 1024px) {
            padding: 24px;
          }
        `}
      >
        <h2
          css={[
            pageCSS.titleStyle,
            css`
              color: #fff;
              text-align: center;
            `,
          ]}
        >
          Information
        </h2>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 8px;

            margin: 0 auto 8px;

            @media screen and (max-width: 1024px) {
              flex-wrap: wrap;
              gap: 8px;
              width: 100%;
              margin-bottom: 8px;
            }

            dl {
              background-color: #fff;
              padding: 8px 16px;
              min-width: 150px;
              width: 24%;
              @media screen and (max-width: 1024px) {
                width: 100%;
              }
            }
            dt {
              color: #d65b56;
              font-weight: bold;
              font-size: 14px;
            }
            dd {
              text-align: right;
              white-space: nowrap;
              font-size: 14px;
            }
          `}
        >
          <dl>
            <dt>Network:</dt>
            <dd>Ethereum</dd>
          </dl>
          <dl>
            <dt>Type:</dt>
            <dd>ERC721</dd>
          </dl>
          <dl>
            <dt>Total Supply:</dt>
            <dd>3600</dd>
          </dl>
          <dl>
            <dt>Price:</dt>
            <dd>Free</dd>
          </dl>
        </div>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 8px;

            margin: 0 auto;

            @media screen and (max-width: 1024px) {
              flex-wrap: wrap;
              gap: 8px;
              width: 100%;
            }

            dl {
              background-color: #fff;
              padding: 8px 16px;
              min-width: 150px;
              width: 36.7%;
              &:last-of-type {
                width: 24%;
              }

              @media screen and (max-width: 1024px) {
                width: 100%;
                &:last-of-type {
                  width: 100%;
                }
              }
            }
            dt {
              color: #d65b56;
              font-weight: bold;
              font-size: 14px;
            }
            dd {
              text-align: right;
              white-space: nowrap;
              font-size: 14px;
            }
          `}
        >
          <dl>
            <dt>AL Mint Date:</dt>
            <dd>DECEMBER 16TH (10AM JST)</dd>
          </dl>
          <dl>
            <dt>Public Mint Date: </dt>
            <dd>DECEMBER 19TH (10AM JST)</dd>
          </dl>
          <dl>
            <dt>Reveal Date: </dt>
            <dd>TBA</dd>
          </dl>
        </div>
      </section>
    </div>
  );
};

export default memo(Information);
